import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["button", "validationMessage"]
  }

  static get values() {
    return {
      defaultButtonText: String,
      formQueryClass: String
    }
  }

  connect() {
    this.panelState = "active"
    this.clearMessage()
    this.renderButton()
  }

  handleClick(event) {
    event.preventDefault()

    this.panelState = "validating"
    this.clearMessage()
    this.renderButton()

    const isValid = this.validateRegistrationForm()
    if (!isValid) {
      this.abort()
      return
    }

    const form = this.formElement()
    if (form) {
      form.submit()
    }
  }

  validateRegistrationForm() {
    const form = this.formElement()
    if (!form) {
      return false
    }

    const detail = { valid: true }
    form.dispatchEvent(
      new CustomEvent("registration:validate-form-response", {
        bubbles: true,
        detail
      })
    )

    if (!detail.valid) {
      return false
    }

    if (!window.$) {
      return true
    }

    if (window.$(form).hasClass("parsley")) {
      window.$(form).parsley().validate()
      return window.$(form).parsley().isValid()
    }

    return true
  }

  abort() {
    this.panelState = "active"
    this.validationMessageTarget.textContent =
      "There's some missing or invalid information in this form. Please review each field and check it's correct."
    this.validationMessageTarget.hidden = false
    this.renderButton()
  }

  clearMessage() {
    if (!this.hasValidationMessageTarget) {
      return
    }

    this.validationMessageTarget.hidden = true
    this.validationMessageTarget.textContent = ""
  }

  renderButton() {
    if (!this.hasButtonTarget) {
      return
    }

    this.buttonTarget.value = this.panelState === "validating" ? "Loading" : this.defaultButtonTextValue
  }

  formElement() {
    const forms = document.getElementsByClassName(this.formQueryClassValue)
    return forms.length > 0 ? forms[0] : null
  }
}
